import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { PageLayoutModule } from '../../global';
import { UserService } from '../../global';
import { AdminMenuSection } from './admin-menu.model';

@Component({
    standalone: true,
    selector: 'abs-admin-menu',
    imports: [CommonModule, IonicModule, RouterModule, PageLayoutModule],
    template: `
        <abs-page-layout [pageTitle]="'Admin Menu'">
            <ion-accordion-group>
                @for (section of visibleSections(); track section.label) {
                    <ion-accordion [value]="section.value || section.label">
                        <ion-item-divider slot="header">
                            <ion-label>{{ section.label }}</ion-label>
                        </ion-item-divider>
                        @for (item of section.items; track item.routerLink) {
                            <ion-item slot="content" [routerLink]="item.routerLink" [queryParams]="item.queryParams ?? {}">
                                <ion-icon [name]="item.icon" slot="start"></ion-icon>
                                <ion-label>{{ item.label }}</ion-label>
                            </ion-item>
                        }
                    </ion-accordion>
                }
            </ion-accordion-group>
        </abs-page-layout>
    `,
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
                flex: 1 1 auto;
                height: 100%;
            }

            ion-item-divider {
                cursor: pointer;
                font-weight: bold;
                color: black;
            }

            ion-item-divider:hover {
                background-color: lightgrey;
            }
        `
    ]
})
export class AdminMenuComponent {
    sections = input<AdminMenuSection[]>([]);

    private userService = inject(UserService);

    visibleSections = computed(() => {
        const user = this.userService.user();
        const userRoles = user?.roles ?? [];
        const isAdmin = userRoles.includes('app_admin');
        const sections = this.sections();
        return sections.filter((s) => {
            if (isAdmin) return true;
            const allowed = s.roles ?? (s.role ? [s.role] : null);
            if (!allowed) return false;
            return allowed.some((r) => userRoles.includes(r));
        });
    });
}
